import { Check, Inbox, Info, Lock } from 'lucide-react'
import { Button } from '../ui/button'

// Empty state for a protected (or unknown) account or folder while offline
// (#785, mockup 1d „geschützt offline"). Nothing of such an account is ever
// stored on the device; there is deliberately no switch to change that.

export function ProtectedOfflineEmpty({
  switchTo,
}: {
  /** First unprotected, enabled account, if one exists. */
  switchTo?: { label: string; onSwitch: () => void }
}) {
  return (
    <div className="flex flex-col gap-3 px-3 py-3 phone:px-4">
      <div className="flex flex-col items-center gap-2.5 rounded-2xl border border-border-subtle bg-bg-elevated/40 px-4 py-7 text-center">
        <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-warning/[0.12] text-warning">
          <Lock className="h-6 w-6" aria-hidden="true" />
        </span>
        <h3 className="text-base font-semibold">Geschütztes Konto – offline nicht verfügbar</h3>
        <p className="text-[13px] leading-relaxed text-text-secondary">
          Mails aus diesem Konto werden nie auf dem Handy gespeichert. Darum ist hier ohne Netz
          nichts zu sehen.
        </p>
        <ul className="mt-1 flex flex-col gap-1.5 text-left text-xs text-text-tertiary">
          <li className="flex items-start gap-2 leading-snug">
            <Check className="mt-0.5 h-3.5 w-3.5 shrink-0 text-success" aria-hidden="true" />
            Kein Offline-Speicher, kein Ausgang für dieses Konto
          </li>
          <li className="flex items-start gap-2 leading-snug">
            <Check className="mt-0.5 h-3.5 w-3.5 shrink-0 text-success" aria-hidden="true" />
            Beim Schließen der App bleibt nichts zurück
          </li>
          <li className="flex items-start gap-2 leading-snug">
            <Info className="mt-0.5 h-3.5 w-3.5 shrink-0" aria-hidden="true" />
            Schreiben geht erst wieder, wenn du online bist
          </li>
        </ul>
      </div>
      {switchTo && (
        <Button variant="secondary" className="min-h-11 w-full" onClick={switchTo.onSwitch}>
          <Inbox className="h-4 w-4" aria-hidden="true" />
          <span className="truncate">Zu „{switchTo.label}“ wechseln</span>
        </Button>
      )}
      <p className="text-center text-xs text-text-tertiary">
        Nicht umstellbar – gilt für alle geschützten Konten und Ordner.
      </p>
    </div>
  )
}
